var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.4 20C4.7 20 0 15.5 0 10S4.7 0 10.4 0s10.4 4.5 10.4 10-4.7 10-10.4 10zm0-18C5.8 2 2 5.6 2 10s3.8 8 8.4 8c4.6 0 8.4-3.6 8.4-8S15 2 10.4 2z","key":0}),React.createElement("path",{"d":"M16.052 16.751l1.383-1.445 10.55 10.093-1.383 1.445z","key":1})]);
}

Search.displayName = "Search";

Search.defaultProps = {"viewBox":"0 0 27.9 26.8"};

module.exports = Search;

Search.default = Search;
